const Colors = {
  goldDark: "#C69F2D",
  gold: "#BA9E5E",
  goldLight: "#D2AF57",
  charcoal: "#55565A",
  black: "#1A1919",
  darkCharcoal: "#1A1919",
  slate: "#99999A",
  stone: "#DBD9D6",
  lightColor: "#fff",
  gray: "#D8D8D8",
  lapis: "#1C4F90",
  red: "#801b1d",
  white: "#FFFFFF",
  mediumGray: "#2F3032",
  lightGrey: "#75767C",
  dustyGray: "#999999",
  boulder: "#797979"
};

export default Colors;
